/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Linked_Group_LabelInputs */

const en_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked Group`)
};

const fr_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe lie`)
};

const de_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfte Gruppe`)
};

const it_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo collegato`)
};

const ru_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связанная группа`)
};

const es_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo vinculado`)
};

const zh_cn2_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接组`)
};

const ja_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクグループ`)
};

const hi_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक्ड ग्रुप`)
};

const pt_pt2_merge_event_group_linked_group_label = /** @type {(inputs: Merge_Event_Group_Linked_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo Vinculado`)
};

/**
* | output |
* | --- |
* | "Linked Group" |
*
* @param {Merge_Event_Group_Linked_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_linked_group_label = /** @type {((inputs?: Merge_Event_Group_Linked_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Linked_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_linked_group_label(inputs)
	if (locale === "de") return de_merge_event_group_linked_group_label(inputs)
	if (locale === "it") return it_merge_event_group_linked_group_label(inputs)
	if (locale === "ru") return ru_merge_event_group_linked_group_label(inputs)
	if (locale === "es") return es_merge_event_group_linked_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_linked_group_label(inputs)
	if (locale === "ja") return ja_merge_event_group_linked_group_label(inputs)
	if (locale === "hi") return hi_merge_event_group_linked_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_linked_group_label(inputs)
	return en_merge_event_group_linked_group_label(inputs)
});